import TenantForm from './component'

export default TenantForm
